import { IApiResponse } from "../../../@types/api-response.type";
import { Api } from "../ApiConfig"
import { ApiException } from "../ApiException"
import { getErrorMessage } from "../../../utils/utils";
import { IProjectImplementedFilter, IProjectImplementedsResponse } from "../../../@types/project/project-implemented.type";

export const searchProjectImplementedByProjectId = async (projectId: string, filter: IProjectImplementedFilter) : Promise<IApiResponse<IProjectImplementedsResponse> | ApiException> => {
  try {
      const { data } = await Api.post<IApiResponse<IProjectImplementedsResponse>>(`/api/ProjectImplemented/SearchProjectImplementedByProjectId/${projectId}`, filter)
      return data;
  } catch (error) {
      throw new ApiException(getErrorMessage(error, 'Erro ao buscar os Projeto'))
  }
}

export const getProjectImplementedByProjectIdAndMonthYear = async (projectId: string, month: number, year: number) : Promise<IApiResponse<IProjectImplementedsResponse> | ApiException> => {
  try {
      const { data } = await Api.get<IApiResponse<IProjectImplementedsResponse>>(`/api/ProjectImplemented/GetProjectImplementedByProjectIdAndMonthYear/${projectId}?month=${month}&year=${year}`,)
      return data;
  } catch (error) {
      throw new ApiException(getErrorMessage(error, 'Erro ao buscar os Projeto'))
  }
}

